var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "marketingProjectEditor" },
    [
      _c(
        "div",
        { staticStyle: { display: "flex", "justify-content": "space-around" } },
        [
          _c(
            "el-button",
            {
              staticStyle: { margin: "10px 20px" },
              attrs: { size: "mini", type: "primary" },
              on: {
                click: function($event) {
                  return _vm.back()
                }
              }
            },
            [_vm._v("返回")]
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-dialog",
                {
                  staticStyle: { "margin-top": "7vh !important" },
                  attrs: {
                    title: "选择队长并组建团队",
                    visible: _vm.formTeamDialogVisible,
                    width: "500px"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.formTeamDialogVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "450px",
                        margin: "0 auto",
                        padding: "10px",
                        background: "#f9f9fa"
                      }
                    },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.UserList, stripe: "" },
                          on: { "selection-change": _vm.handleSelectionChange }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "selection", width: "55" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "id", label: "序号", width: "80" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "studentName", label: "姓名" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "studentNumber", label: "学号" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作", width: "120" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function($event) {
                                            return _vm.delstu(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v(" 删除 ")]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "selectePages" },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.totalObj.currentPage,
                              background: "",
                              "page-sizes": [10, 20, 50, 100],
                              "page-size": _vm.totalObj.pageSize,
                              layout: "sizes, prev, pager, next",
                              total: _vm.totalObj.total
                            },
                            on: {
                              "size-change": _vm.classCompanySizeChange,
                              "current-change": _vm.classCompanyCurrentChange,
                              "update:currentPage": function($event) {
                                return _vm.$set(
                                  _vm.totalObj,
                                  "currentPage",
                                  $event
                                )
                              },
                              "update:current-page": function($event) {
                                return _vm.$set(
                                  _vm.totalObj,
                                  "currentPage",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.formTeamDialogVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.companyTeamFuntion()
                            }
                          }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { margin: "10px 20px" },
                  attrs: { size: "mini", type: "primary", plain: "" },
                  on: {
                    click: function($event) {
                      return _vm.addStuStaff()
                    }
                  }
                },
                [_vm._v("组件团队\n        ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.Transfer == 1
        ? _c(
            "div",
            [
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "添加学生",
                    "custom-class": "add_stu",
                    center: "",
                    width: "982px",
                    "show-close": false,
                    visible: _vm.centereDialogVisible,
                    "close-on-press-escape": false,
                    "close-on-click-modal": false,
                    "before-close": _vm.add_all_student_cancel
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.centereDialogVisible = $event
                    }
                  }
                },
                [
                  _c("div", { staticClass: "sudent-contents" }, [
                    _c("div", { staticClass: "sudent-content" }, [
                      _c("div", { staticClass: "selected tobe" }, [
                        _c("div", { staticClass: "seach" }, [
                          _c("span", [_vm._v("待选")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "training-site" },
                            [
                              _c(
                                "el-input",
                                {
                                  staticStyle: {
                                    width: "200px",
                                    height: "28px",
                                    float: "left"
                                  },
                                  attrs: {
                                    placeholder: "请输入姓名/学号/手机号/账号",
                                    size: "mini"
                                  },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search_student.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.queryVal,
                                    callback: function($$v) {
                                      _vm.queryVal = $$v
                                    },
                                    expression: "queryVal"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-input__icon el-icon-search",
                                    attrs: { slot: "suffix" },
                                    on: { click: _vm.search_student },
                                    slot: "suffix"
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择行政班",
                                    clearable: ""
                                  },
                                  on: { change: _vm.teachingClassChange },
                                  model: {
                                    value: _vm.teachingClass,
                                    callback: function($$v) {
                                      _vm.teachingClass = $$v
                                    },
                                    expression: "teachingClass"
                                  }
                                },
                                _vm._l(_vm.options, function(item, key) {
                                  return _c("el-option", {
                                    key: key,
                                    attrs: { label: item, value: item }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "left-table" },
                          [
                            _c(
                              "el-table",
                              {
                                ref: "multipleTable2",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  data: _vm.tableData_3,
                                  "cell-style": _vm.cellStyle3,
                                  "header-cell-style": _vm.headerCellStyle3,
                                  "row-style": { border: 0 },
                                  height: "256px",
                                  "row-key": _vm.getRowKey
                                },
                                on: { "selection-change": _vm.check_student }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    width: "50",
                                    type: "selection",
                                    align: "center",
                                    "reserve-selection": true
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { prop: "name", label: "姓名" }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "studentNumber",
                                    label: "学号"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "teachingClass",
                                    label: "行政班"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pages" },
                          [
                            _c("el-pagination", {
                              attrs: {
                                "current-page": _vm.currentPage2,
                                background: "",
                                "page-sizes": [10, 20, 50, 100],
                                "page-size": _vm.pageSize,
                                "pager-count": 5,
                                layout: "sizes, prev, pager, next",
                                total: _vm.studentTotal
                              },
                              on: {
                                "size-change": _vm.handleSizeChange2,
                                "current-change": _vm.handleCurrentChange2,
                                "update:currentPage": function($event) {
                                  _vm.currentPage2 = $event
                                },
                                "update:current-page": function($event) {
                                  _vm.currentPage2 = $event
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "box_button" },
                        [
                          _c("el-button", {
                            staticClass: "button_top",
                            attrs: {
                              type: "primary",
                              disabled: !_vm.table_student.length,
                              icon: "el-icon-arrow-right",
                              circle: ""
                            },
                            on: { click: _vm.add_active }
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            attrs: {
                              type: "primary",
                              disabled: !_vm.table_student2.length,
                              icon: "el-icon-arrow-left",
                              circle: ""
                            },
                            on: { click: _vm.remove_active }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "selected" }, [
                        _c("div", { staticClass: "seach" }, [
                          _c("span", [_vm._v("已选")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "training-site" },
                            [
                              _c(
                                "el-input",
                                {
                                  staticStyle: {
                                    width: "210px",
                                    height: "28px"
                                  },
                                  attrs: {
                                    placeholder: "请输入姓名/学号/手机号/账号",
                                    size: "mini"
                                  },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.query_student2(_vm.queryVal2)
                                    }
                                  },
                                  model: {
                                    value: _vm.queryVal2,
                                    callback: function($$v) {
                                      _vm.queryVal2 = $$v
                                    },
                                    expression: "queryVal2"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-input__icon el-icon-search",
                                    attrs: { slot: "suffix" },
                                    on: {
                                      click: function($event) {
                                        return _vm.query_student2(_vm.queryVal2)
                                      }
                                    },
                                    slot: "suffix"
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {},
                          [
                            _c(
                              "el-table",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  data: _vm.tagList,
                                  "cell-style": _vm.cellStyle3,
                                  "header-cell-style": _vm.headerCellStyle3,
                                  "row-style": { border: 0 },
                                  height: "301px"
                                },
                                on: { "selection-change": _vm.check_student2 }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    width: "50",
                                    type: "selection",
                                    align: "center"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { prop: "name", label: "姓名" }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "studentNumber",
                                    label: "学号"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "teachingClass",
                                    label: "行政班"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        { on: { click: _vm.add_all_student_cancel } },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.add_all_student }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.StuStaff == 1
        ? _c(
            "div",
            [
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "提示",
                    visible: _vm.dialogVisible,
                    width: "926px",
                    "border-radius": "25px"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible = $event
                    }
                  }
                },
                [
                  _c("span"),
                  _vm._v(" "),
                  _vm._l(_vm.subjectIds, function(item, id) {
                    return _c("div", { key: id }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            border: "#e6e8f1 1px solid",
                            display: "flex",
                            "flex-direction": "column"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                margin: "0px 0 5px 0",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    height: "30px",
                                    "background-color": "#e6e8f1",
                                    display: "flex",
                                    "align-items": "center"
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(item.projectName))])]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    "justify-content": "space-between"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("指派给:")]),
                                  _vm._v(" "),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        title: "标题",
                                        width: "200",
                                        trigger: "click"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column"
                                          },
                                          model: {
                                            value: item.checkList,
                                            callback: function($$v) {
                                              _vm.$set(item, "checkList", $$v)
                                            },
                                            expression: "item.checkList"
                                          }
                                        },
                                        _vm._l(_vm.UserList, function(a, id) {
                                          return _c(
                                            "div",
                                            { key: id },
                                            [
                                              _c(
                                                "el-checkbox",
                                                { attrs: { label: a } },
                                                [_vm._v(_vm._s(a.studentName))]
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            border: "none",
                                            "background-color": "white"
                                          },
                                          attrs: {
                                            slot: "reference",
                                            size: "mini"
                                          },
                                          slot: "reference"
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-circle-plus-outline",
                                            staticStyle: {
                                              "font-size": "20px"
                                            },
                                            on: { click: _vm.addstu }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            _vm._l(item.checkList, function(tag) {
                              return _c(
                                "el-tag",
                                {
                                  key: tag.studentName,
                                  staticStyle: { margin: "5px" },
                                  attrs: { closable: "" }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(tag.studentName) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ]
                      )
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.dialogVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.addStuProject }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-wrap": "wrap",
            margin: "0 auto",
            background: "white",
            height: "90%"
          }
        },
        _vm._l(_vm.companyTeamList, function(item, id) {
          return _c(
            "el-card",
            {
              key: id,
              staticClass: "box-card",
              staticStyle: { position: "relative" }
            },
            [
              _c(
                "p",
                { staticStyle: { "font-size": "18px", "font-weight": "600" } },
                [_vm._v(_vm._s(item.userList[0].studentName) + "的项目组")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex", margin: "10px 0px" } },
                [
                  _c("p", { staticStyle: { width: "50px", flex: "none" } }, [
                    _vm._v("成员：")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "150px",
                        display: "flex",
                        "flex-wrap": "wrap",
                        overflow: "hidden",
                        "text-overflow": "ellipsis",
                        "white-space": "nowrap"
                      }
                    },
                    _vm._l(item.userList, function(a, id) {
                      return _c(
                        "span",
                        {
                          key: id,
                          staticStyle: {
                            "font-size": "12px",
                            "margin-right": "3px"
                          }
                        },
                        [_vm._v(_vm._s(a.studentName) + "  、")]
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    bottom: "0px",
                    right: "20px"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function($event) {
                          return _vm.editStudent(item.userList)
                        }
                      }
                    },
                    [_vm._v("编辑")]
                  )
                ],
                1
              )
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "团队名单",
            visible: _vm.EditStatusDialogVisible,
            width: "45%"
          },
          on: {
            "update:visible": function($event) {
              _vm.EditStatusDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                width: "30%",
                title: "新增学员",
                visible: _vm.innerVisible,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.innerVisible = $event
                }
              }
            },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.UserList, "tooltip-effect": "dark" },
                  on: { "selection-change": _vm.handleSelectionStudentChange }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [_vm._v(_vm._s(scope.$index + 1))]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "studentName", label: "姓名" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-around"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function($event) {
                          return _vm.addStudentForTeam()
                        }
                      }
                    },
                    [_vm._v("新增")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function($event) {
                          _vm.innerVisible = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: {
                click: function($event) {
                  return _vm.addStudent()
                }
              }
            },
            [_vm._v("新增成员")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: {
                click: function($event) {
                  return _vm.delStudent()
                }
              }
            },
            [_vm._v("删除成员")]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.teamStudentList, "tooltip-effect": "dark" },
              on: { "selection-change": _vm.handleSelectionStudentChange }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "序号", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_vm._v(_vm._s(scope.$index + 1))]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "studentName", label: "姓名" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "团队身份" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(_vm._s(scope.$index == 0 ? "队长" : "队员"))
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.EditStatusDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.EditStatus()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18420dec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18420dec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auditNewRealTask/components/marketingProjectEditor.vue
// module id = null
// module chunks = 